import React from 'react'
import { RenderControl, IRenderControl } from '@fareye/ui'
import { IMapper, useMapper } from '@fareye/common'
import { AlertSettings } from '.'
import version from '../../config/npmVersions'

export function AlertSettingsMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <RenderControl variant="m" state={apiData as IRenderControl}>
      <AlertSettings {...props} config={(apiData as IRenderControl).data} />
    </RenderControl>
  )
}
